import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  text?: string;
  className?: string;
}

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
  xl: 'h-16 w-16',
};

const textSizes = {
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-base',
  xl: 'text-lg',
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  text,
  className = '',
}) => {
  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div className="relative">
        <div
          className={`animate-spin rounded-full border-4 border-blue-200 ${sizeClasses[size]}`}
        ></div>
        <div
          className={`absolute top-0 left-0 animate-spin rounded-full border-4 border-transparent border-t-blue-600 ${sizeClasses[size]}`}
          style={{ animationDuration: '1.5s' }}
        ></div>
      </div>
      {text && (
        <span className={`mt-3 text-gray-600 font-medium animate-pulse ${textSizes[size]}`}>
          {text}
        </span>
      )}
    </div>
  );
};
